import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction, { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditAttachmentModal from '@modals/CreateOrEditAttachmentModal'

import type { AttachmentModel } from '@models/types'

import PageContent from './components/PageContent'

const defaultState = {
  showCreateOrEditAttachmentModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    CreateOrEditAttachmentModal: {
      closeModal: () => setState({ showCreateOrEditAttachmentModal: false }),
      deleteAttachment: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateAttachment: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const Details = (props: { notificationId: number }) => {
  const { notificationId } = props

  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditAttachmentModal } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      deleteAttachment: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      showCreateOrEditAttachmentModal: (payload: { attachment: AttachmentModel }) => {
        setModalData('CreateOrEditAttachmentModal', payload)
        setState({ showCreateOrEditAttachmentModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent notificationId={notificationId} />

        <CreateOrEditAttachmentModal
          callbacks={callbacks('CreateOrEditAttachmentModal', setState)}
          showModal={showCreateOrEditAttachmentModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>

  )
}

export default Details
